<template>
  <section class="pump__details__section_2">
    <div class="row add_driver_row record__expenses">
      <div class="col-md-12 col-lg-12">
        <ejs-grid
          v-show="!showLoader"
          ref="dataGrid"
          :created="refreshGrid"
          :allowPaging="true"
          :allowSorting="true"
          :pageSettings="pageSettings"
          :toolbar="toolbar"
          :searchSettings="search"
          :allowTextWrap="true"
          :allowExcelExport="true"
          :allowPdfExport="true"
          :toolbarClick="toolbarClick"
          :locale="usedLang"
        >
          <e-columns>
            <e-column width="70" field="index" headerText="#"></e-column>
            <!-- <e-column
              field="fullName"
              width="200"
              :headerText="$t('text.cTrucks.driver')"
            ></e-column> -->
            <e-column
              field="firstName"
              width="100"
              :headerText="$t('text.form.firstName')"
            ></e-column>
            <e-column
              field="lastName"
              width="100"
              :headerText="$t('text.form.lastName')"
            ></e-column>
            <e-column
              field="name"
              width="150"
              :headerText="$t('text.manageTrucks.truckName')"
            ></e-column>
            <e-column
              field="plateNumber"
              width="150"
              :headerText="$t('text.manageTrucks.plateNumber')"
            ></e-column>
            <e-column
              field="phone"
              width="150"
              :headerText="$t('text.cTrucks.phoneNo')"
              type="number"
            ></e-column>
            <e-column
              field="tankType"
              width="100"
              type="number"
              :headerText="$t('text.cTrucks.tankType')"
            ></e-column>
            <e-column
              field="email"
              width="250"
              type="text"
              :headerText="$t('text.cTrucks.email')"
            ></e-column>
          </e-columns>
        </ejs-grid>
        <TableLoader :showLoader="showLoader" />
      </div>
    </div>
  </section>
</template>

<script>
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  components: {
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  props: ["companyId"],
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      // company: null,
      showLoader: true,
      truckId: "",
      formatOptions: { type: "date", format: "dd/MM/yyyy" },
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search", "ExcelExport", "PdfExport"],
      search: { operator: "contains", ignoreCase: true },
    };
  },
  created() {},
  mounted() {
    this.getDriversWithTruck();
    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          let pdfExportProperties = {
            pageOrientation: "Landscape",
            fileName: "Assigned_Truck_List.pdf",
          };
          this.$refs.dataGrid.getColumns()[0].width = "80";
          this.$refs.dataGrid.getColumns()[1].width = "200";
          this.$refs.dataGrid.getColumns()[2].width = "140";
          this.$refs.dataGrid.getColumns()[3].width = "200";
          this.$refs.dataGrid.getColumns()[4].width = "200";
          this.$refs.dataGrid.getColumns()[5].width = "200";
          this.$refs.dataGrid.getColumns()[5].width = "120";
          this.$refs.dataGrid.getColumns()[6].width = "120";
          this.$refs.dataGrid.getColumns()[7].width = "120";
          this.$refs.dataGrid.pdfExport(pdfExportProperties);
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {},
    getDriversWithTruck() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Delivery/CompanyDriversWithTruck/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.companyId
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          // console.log(response);
          this.showLoader = false;
          let index = 0;
          response.data.sort((a, b) => {
            return a.firstName > b.firstName
              ? 1
              : b.firstName > a.firstName
              ? -1
              : 0;
          });
          response.data.forEach((element) => {
            element.index = ++index;
            element.dateUnformatted = element.date;
            element.fullName = `${element.firstName} ${element.lastName}`;
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.$eventHub.$emit("getDriversWithTruck");
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>

<style></style>
